import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-background-50/20 rounded-lg">
                <i className="ri-book-open-line text-xl"></i>
              </div>
              <span className="font-heading text-xl">虫虫漫画网</span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              下拉式完整版免费阅读平台，专注提供无删减韩国漫画资源，
              下拉观看流畅不卡顿，为您呈现各类精彩韩国漫画的完整版剧情与画面。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/category/hot" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">热门推荐</Link>
              <Link to="/category/romance" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">恋爱言情</Link>
              <Link to="/category/fantasy" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">奇幻冒险</Link>
              <Link to="/category/action" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">动作热血</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">品牌介绍</Link>
              <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">用户口碑</Link>
              <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
              <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">常见问题</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">联系方式</h4>
            <div className="flex flex-col gap-3 text-sm text-background-50/70">
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <span>contact@chongchongmanhua.com</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-customer-service-line text-sm"></i>
                </div>
                <span>在线客服：周一至周日 9:00-22:00</span>
              </div>
              <div className="flex gap-3 mt-2">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-50/50">
          <p>&copy; 2026 虫虫漫画网 - 下拉式完整版免费阅读平台，版权所有。</p>
          <p>本站所有漫画资源均来自互联网，仅供学习交流使用。</p>
        </div>
      </div>
    </footer>
  );
}